import { request } from '@/network/request'

export const uploadImg = (fd) => {
  return request({
    url: '/device/product/uploadImg',
    method: 'post',
    // headers:{
    //   'content-type':'multipart/form-data'
    // },
    data: fd
  })
}

// 省
export function getProductAddress () {
  return request({
    url: '/publishing/housekeeper/getProductAddress',
    method: 'get',
  })
}

// 市和县
export function getCityAddress (query) {
  return request({
    url: '/publishing/housekeeper/getCityAddress',
    method: 'get',
    params: query
  })
}

// ---------------------------------------------------开始-个人中心-我的信息--------------------------------------------------
//获取类型
export const mechanismGetIndustryList = (type) => {
  return request({
    url: '/mechanism/getIndustryList?industryType=' + type
  })
}

//健康档案

//实名认证
export const professionalQueryRealById = (userId) => {
  return request({
    url: 'professional/queryRealById?userId=' + userId,
  })
}

//资质认证

//资质认证  专家
export const professionalSettleIn = (userId) => {
  return request({
    url: 'professional/settleIn?userId=' + userId,
  })
}

//资质认证  专家  实名认证
export const professionalSaveRealName = (user) => {
  return request({
    url: 'professional/saveRealName',
    method: 'post',
    data: JSON.stringify(user)
    // params:user
  })
}


//资质认证  专家  简介
export const professionalSaveProfessional = (user) => {
  return request({
    url: '/professional/saveProfessional',
    method: 'post',
    data: JSON.stringify(user)
  })
}

// 所属行业
export const echanismGetIndustryList = () => {
  return request({
    url: '/mechanism/getIndustryList'
  })
}


//资质认证  专家  审核状态
export const zjshenheAjax = (user) => {
  return request({
    url: '/avatar',
    method: 'post',
    data: user
  })
}
//资质认证  点击机构入驻
export const mechanismSettleIn = (userId) => {
  return request({
    url: '/mechanism/settleIn?userId=' + userId,
  })
}
//资质认证  机构  基本信息
export const mechanismSaveMechanismInfo = (data) => {
  return request({
    url: '/mechanism/saveMechanismInfo',
    method: 'post',
    params: data
  })
}

//资质认证  机构  相关资质
export const mechanismSaveMechanism = (data) => {
  return request({
    url: 'mechanism/saveMechanism',
    method: 'post',
    params: data
  })
}

//资质认证  机构  提交状态
export const jigoushenheAjax = (user) => {
  return request({
    url: '/avatar',
    method: 'post',
    data: user
  })
}



// ---------------------------------------------------开始-个人中心-我的信息--------------------------------------------------



// WEBPACK FOOTER //
// ./src/api/myInfo.js